"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import * as _interactions from "./webflow_modules/interactions";
import { AdvSearchAmenitiesDropdown2 } from "./AdvSearchAmenitiesDropdown2";
import { AdvSearchBedroomGroup } from "./AdvSearchBedroomGroup";
import { AdvSearchOpenCloseMapToggle } from "./AdvSearchOpenCloseMapToggle";
import { AdvSearchRentRange } from "./AdvSearchRentRange";
import { AdvSearchSearchInput } from "./AdvSearchSearchInput";
import { PropertyCardNoResults } from "./PropertyCardNoResults";
import { RedoSearchButton } from "./RedoSearchButton";

const _interactionsData = JSON.parse(
  '{"events":{"e-97":{"id":"e-97","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-98"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"65ee92366d1cabac2751eed9|e4f8b83c-b3fe-4636-e67f-a0c83bf4bd7b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"65ee92366d1cabac2751eed9|e4f8b83c-b3fe-4636-e67f-a0c83bf4bd7b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1707328603317}},"actionLists":{"a-39":{"id":"a-39","title":"Close Filter","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"PARENT","selector":".modal---position-100-off-page-0","selectorGuids":["a380fd88-6847-6370-dd56-eb80950989f6"]},"value":0,"unit":""}},{"id":"a-39-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"PARENT","selector":".modal---position-100-off-page-0","selectorGuids":["a380fd88-6847-6370-dd56-eb80950989f6"]},"xValue":-126,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".modal---position-100-off-page-0","selectorGuids":["a380fd88-6847-6370-dd56-eb80950989f6"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1706910099212}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function AdvSearchComponentsWrapper({
  children = "",
  mapSlot = "",
  modalChildren = "",
  redoButtonSlot = "",
  resetSearchRuntimeProps = {},
  searchButtonProps = {},
  showAdvSearch = true,
  showDesktopFilterButton = true,
  showNoResults = false,
  textMarketName = "search here",
  textSearchButton = "Show 11 Apartments",
  toggleFilterButtonProps = {},
  toggleMapButtonProps = {},
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <Block className={"frame-210-v2"} tag={"div"}>
      <Block className={"div-block-80"} tag={"div"}>
        <Block className={"search-rows"} tag={"div"}>
          <Block className={"search-components"} tag={"div"}>
            {showAdvSearch ? (
              <Block className={"adv-search-components-slot"} tag={"div"}>
                {children ?? (
                  <>
                    <Block className={"location-group"} tag={"div"}>
                      <AdvSearchSearchInput
                        showClearButton={true}
                        showList={false}
                      />
                    </Block>
                    <AdvSearchBedroomGroup />
                    <Block className={"location-group"} tag={"div"}>
                      <AdvSearchAmenitiesDropdown2
                        buttonText={"Amenities (2)"}
                        showButton={true}
                        showInline={false}
                        showPopover={false}
                      />
                    </Block>
                    <AdvSearchRentRange />
                  </>
                )}
              </Block>
            ) : null}
            {showAdvSearch ? (
              <Block className={"div-block-113"} tag={"div"}>
                <Block
                  className={"text-size-tiny text-style-italic"}
                  tag={"div"}
                >
                  {"Prices subject to change"}
                </Block>
              </Block>
            ) : null}
            {showDesktopFilterButton ? (
              <Block className={"seo-search-bar"} tag={"div"}>
                <Block className={"desktop-show-filter-button"} tag={"div"}>
                  <Block className={"show-desktop-landscape-copy"} tag={"div"}>
                    <Link
                      block={"inline"}
                      button={false}
                      className={"button is-filter is-small with-text"}
                      id={
                        "w-node-f3b90877-0431-a2e9-cb20-6b86ee952623-3e5c01a9"
                      }
                      options={{
                        href: "#",
                      }}
                      {...toggleFilterButtonProps}
                    >
                      <Block className={"text-block-9"} tag={"div"}>
                        {textMarketName}
                      </Block>
                      <Block className={"div-block-98"} tag={"div"}>
                        <HtmlEmbed
                          className={"icon-embed-xxsmall-copy"}
                          content={
                            '<svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 512 512"><path fill="currentColor" d="M0 416c0 8.8 7.2 16 16 16l65.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 432c8.8 0 16-7.2 16-16s-7.2-16-16-16l-257.6 0c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64L16 400c-8.8 0-16 7.2-16 16zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-80c-38.7 0-71 27.5-78.4 64L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l257.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l65.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-65.6 0c-7.4-36.5-39.7-64-78.4-64zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm78.4-64C263 43.5 230.7 16 192 16s-71 27.5-78.4 64L16 80C7.2 80 0 87.2 0 96s7.2 16 16 16l97.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 112c8.8 0 16-7.2 16-16s-7.2-16-16-16L270.4 80z"/></svg>'
                          }
                        />
                      </Block>
                    </Link>
                    <Block className={"show-map-toggle-container"} tag={"div"}>
                      <AdvSearchOpenCloseMapToggle
                        showCloseButton={false}
                        toggleMapButtonProps={{
                          ...toggleMapButtonProps,
                        }}
                      />
                    </Block>
                  </Block>
                  <Block className={"div-block-113"} tag={"div"}>
                    <Block
                      className={"text-size-tiny text-style-italic"}
                      tag={"div"}
                    >
                      {"Prices subject to change"}
                    </Block>
                  </Block>
                </Block>
              </Block>
            ) : null}
          </Block>
        </Block>
        <Block className={"modal---position-100-off-page-0"} tag={"div"}>
          <Block className={"div-block-78"} tag={"div"}>
            <Block className={"modal-container-for-deskop-search"} tag={"div"}>
              {modalChildren ?? (
                <>
                  <Block className={"location-group"} tag={"div"}>
                    <AdvSearchSearchInput showList={true} />
                  </Block>
                  <AdvSearchBedroomGroup />
                  <Block className={"location-group"} tag={"div"}>
                    <AdvSearchAmenitiesDropdown2
                      showButton={true}
                      showInline={true}
                      showPopover={false}
                    />
                  </Block>
                  <AdvSearchRentRange />
                </>
              )}
            </Block>
            <Link
              block={"inline"}
              button={false}
              className={"adv-search_close-button"}
              options={{
                href: "#",
              }}
              {...toggleFilterButtonProps}
            >
              <HtmlEmbed
                className={"html-embed-4"}
                content={
                  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>'
                }
              />
              <Block className={"text-block-18"} tag={"div"}>
                {"close"}
              </Block>
            </Link>
            <Link
              button={true}
              className={"desktop-search-button"}
              options={{
                href: "#",
              }}
              {...searchButtonProps}
            >
              {textSearchButton}
            </Link>
          </Block>
          <Block
            className={"modal_close-trigger"}
            tag={"div"}
            {...toggleFilterButtonProps}
          />
        </Block>
        <Block className={"adv-search-components-modal-dekstop"} tag={"div"} />
        <Block className={"map---position-100-off-page"} tag={"div"}>
          <Block className={"map-slot-container"} tag={"div"}>
            {mapSlot ?? (
              <Image
                alt={""}
                className={"image-15"}
                height={"auto"}
                loading={"lazy"}
                src={
                  "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/6572534a87098e4ee3860ed5_map.png"
                }
                width={"auto"}
              />
            )}
          </Block>
          <Block className={"div-block-92"} tag={"div"}>
            <Block className={"map-redo-search-button-container"} tag={"div"}>
              {redoButtonSlot ?? <RedoSearchButton showShowDisabled={false} />}
            </Block>
            <Block className={"map-openclose-component-container"} tag={"div"}>
              <AdvSearchOpenCloseMapToggle
                showCloseButton={true}
                toggleMapButtonProps={{
                  ...toggleMapButtonProps,
                }}
              />
            </Block>
            {showNoResults ? (
              <Block className={"map-no-results-container"} tag={"div"}>
                <Block
                  className={"map-no-results-component-container"}
                  tag={"div"}
                >
                  <PropertyCardNoResults
                    resetSearchRuntimeProps={{
                      ...resetSearchRuntimeProps,
                    }}
                  />
                </Block>
              </Block>
            ) : null}
          </Block>
        </Block>
      </Block>
    </Block>
  );
}
